import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// After each route change, move focus to #main-content (the skip-link target, tabIndex -1)
// so keyboard/AT users land in the new page, and announce the page via the provided
// aria-live announce(). Coordinates with the existing ScrollToTop (which handles scroll).
// Skips the first mount so it never steals initial page focus.
export function useFocusOnRouteChange(announce) {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (typeof document === 'undefined') return;
    const main = document.getElementById('main-content');
    if (!main) return;
    if (typeof main.focus === 'function') {
      try {
        main.focus({ preventScroll: true });
      } catch (e) {
        main.focus();
      }
    }
    const heading = main.querySelector('h1');
    const title = (heading && heading.textContent && heading.textContent.trim()) || document.title || '';
    if (announce && title) announce('navigation', title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
}
